import {ReminderNotificationDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";

/**
 * Lead reminder notification class data.
 */
export default class ReminderNotificationData {
	/**
	 * @param {string} content Note content.
	 * @param {string} leadId Lead Id which was noted.
	 * @param {string} referenceNumber Lead referenceNumber which was noted.
	 * @param {string} noteId Note Id.
	 * @param {string} creator Note creator.
	 */
	constructor(readonly content: string,
		readonly leadId: string,
		readonly referenceNumber: string,
		readonly noteId: string,
		public readonly creator: AuthenticatedEntity) {}

	static fromJson(json: ReminderNotificationDataApiDto): ReminderNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new ReminderNotificationData(json.text, json.leadId, json.referenceNumber, json.noteId, creator);
	}

	getLeadReferenceNumber() {
		return this.referenceNumber;
	}
}